import { useCallback } from 'react';
import { useMemo } from 'react';
import { MyOrganizationsDatabasesAndRevisions } from 'libs/end-to-end/src/types/me/my-organizations-databases-and-revisions';
import { Nullable } from 'libs/end-to-end/src/ui-types';
import { ReadPatternHook } from 'apps/sigma2-ui/src/lib/hooks/useReadPattern';
import { useSimpleReadPattern } from 'apps/sigma2-ui/src/lib/hooks/useSimpleReadPattern';
import { getApiBaseUrl } from 'apps/sigma2-ui/src/constants/environment';

export const useMyOrganizationsDatabasesAndRevisions = ({
  needsFullRevisions,
}: {
  needsFullRevisions: boolean;
}): {
  myOrganizationsDatabasesAndRevisions: Nullable<MyOrganizationsDatabasesAndRevisions>;
  status: ReadPatternHook<MyOrganizationsDatabasesAndRevisions>['status'];
} => {
  const getUrlFn = useCallback(
    () =>
      `${getApiBaseUrl()}/me/organizations-databases-and-revisions?optimizationMode=${encodeURIComponent(needsFullRevisions ? 'default' : 'revision-lite')}`,
    [needsFullRevisions],
  );

  const myOrganizationsDatabasesAndRevisionsResult = useSimpleReadPattern({
    getUrlFn,
    canRead: true,
    responseSchema: MyOrganizationsDatabasesAndRevisions,
  });

  const myOrganizationsDatabasesAndRevisions = useMemo(() => {
    if (myOrganizationsDatabasesAndRevisionsResult.status === 'done') {
      return myOrganizationsDatabasesAndRevisionsResult.entity;
    }

    return { organizations: {} };
  }, [myOrganizationsDatabasesAndRevisionsResult]);
  return useMemo(() => {
    return {
      status: myOrganizationsDatabasesAndRevisionsResult.status,
      myOrganizationsDatabasesAndRevisions,
    };
  }, [
    myOrganizationsDatabasesAndRevisionsResult,
    myOrganizationsDatabasesAndRevisions,
  ]);
};
